import React, { useState } from 'react';
import { getRequest, patchRequest } from '../../utils/axiosRequests';

function Dashboard() {
  const [organizationId, setOrganizationId] = useState('');
  const [orgName, setOrgName] = useState('');
  const [videoUrl, setVideoUrl] = useState('');
  const [message, setMessage] = useState({ text: '', isError: false });
  const [isFetching, setIsFetching] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [orgLoaded, setOrgLoaded] = useState(false);

  const fetchOrganization = async () => {
    if (!organizationId.trim()) return;
    setIsFetching(true);
    setMessage({ text: '', isError: false });
    setOrgLoaded(false);
    try {
      const data = await getRequest(`organizations/${organizationId.trim()}`);
      setOrgName(data.name || '');
      setVideoUrl(data.adVideoUrl || '');
      setOrgLoaded(true);
    } catch {
      setMessage({ text: 'Organization not found.', isError: true });
    }
    setIsFetching(false);
  };

  const saveVideoUrl = async () => {
    if (!organizationId.trim()) return;
    setIsSaving(true);
    setMessage({ text: '', isError: false });
    try {
      await patchRequest(`organizations/${organizationId.trim()}`, {
        adVideoUrl: videoUrl.trim(),
      });
      setMessage({ text: 'Video URL saved successfully.', isError: false });
    } catch {
      setMessage({ text: 'Failed to save. Please try again.', isError: true });
    }
    setIsSaving(false);
  };

  const clearVideoUrl = async () => {
    setVideoUrl('');
  };

  return (
    <div style={{ maxWidth: 560, margin: '48px auto', padding: '0 16px' }}>
      <h5 style={{ fontWeight: 700, marginBottom: 24 }}>
        Appointment Display — Video Settings
      </h5>

      <div style={{ marginBottom: 16 }}>
        <label style={labelStyle}>Organization ID</label>
        <div style={{ display: 'flex', gap: 8 }}>
          <input
            className="form-control"
            value={organizationId}
            onChange={(e) => {
              setOrganizationId(e.target.value);
              setOrgLoaded(false);
              setOrgName('');
              setVideoUrl('');
              setMessage({ text: '', isError: false });
            }}
            placeholder="Paste organization ID"
          />
          <button
            className="btn btn-outline-primary"
            onClick={fetchOrganization}
            disabled={isFetching || !organizationId.trim()}
            style={{ whiteSpace: 'nowrap' }}
          >
            {isFetching ? 'Loading…' : 'Load'}
          </button>
        </div>
      </div>

      {orgLoaded && (
        <>
          <p style={{ color: '#555', marginBottom: 20 }}>
            Organization: <strong>{orgName}</strong>
          </p>

          <div style={{ marginBottom: 8 }}>
            <label style={labelStyle}>YouTube Video URL</label>
            <input
              className="form-control"
              value={videoUrl}
              onChange={(e) => setVideoUrl(e.target.value)}
              placeholder="https://www.youtube.com/watch?v=..."
            />
            <small style={{ color: '#888' }}>
              Supports youtube.com/watch?v= and youtu.be/ formats. Leave blank
              to hide the video panel.
            </small>
          </div>

          <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
            <button
              className="btn btn-primary"
              onClick={saveVideoUrl}
              disabled={isSaving}
            >
              {isSaving ? 'Saving…' : 'Save'}
            </button>
            {videoUrl && (
              <button
                className="btn btn-outline-danger"
                onClick={clearVideoUrl}
                disabled={isSaving}
              >
                Clear URL
              </button>
            )}
          </div>
        </>
      )}

      {message.text && (
        <p
          style={{
            marginTop: 16,
            color: message.isError ? '#c0392b' : '#27ae60',
            fontWeight: 500,
          }}
        >
          {message.text}
        </p>
      )}
    </div>
  );
}

const labelStyle = {
  display: 'block',
  fontWeight: 600,
  marginBottom: 6,
  fontSize: '0.9rem',
};

export default Dashboard;
